// components/editor/Editor.jsx
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import EditorJS from "@editorjs/editorjs";
import { getTools } from "./tools";

const parse = (value) => {
  if (!value) return { blocks: [] };
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch {
      return { blocks: [] };
    }
  }
  return value;
};

const Editor = forwardRef(function Editor(
  {
    value,
    onChange,
    preset = "full",
    placeholder = "Агуулгаа энд бичнэ үү...",
    minHeight = 200,
    className,
  },
  ref,
) {
  const holderRef = useRef(null);
  const editorRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useImperativeHandle(ref, () => ({
    save: async () => {
      if (!editorRef.current) return null;
      await editorRef.current.isReady;
      return editorRef.current.save();
    },
  }));

  useEffect(() => {
    const editor = new EditorJS({
      holder: holderRef.current,
      tools: getTools(preset),
      data: parse(value),
      placeholder,
      minHeight,
      async onChange(api) {
        if (!onChangeRef.current) return;
        onChangeRef.current(await api.saver.save());
      },
    });
    editorRef.current = editor;

    return () => {
      editorRef.current = null;
      editor.isReady.then(() => editor.destroy()).catch(() => {});
    };
  }, []);

  return <div ref={holderRef} className={className} />;
});

export default Editor;
